// import S3 from 'react-aws-s3';

function objectToFormData(obj, form = null, namespace = '') {
    const formData = form || new FormData();
    // console.log(obj, form, namespace);
    Object.entries(obj).forEach(([key, value]) => {
      const formKey = namespace ? `${namespace}[${key}]` : key;

      if (value instanceof File || value instanceof Blob) {
        formData.append(formKey, value);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          // Handle array of objects or primitives
          if (typeof item === 'object' && item !== null) {
            objectToFormData(item, formData, `${formKey}[${index}]`);
          } else {
            formData.append(`${formKey}[]`, item);
          }
        });
      } else if (typeof value === 'object' && value !== null) {
        // Recursively handle nested objects
        objectToFormData(value, formData, formKey);
      } else {
        formData.append(formKey, value);
      }
    });

    return formData;
  }

// s3 configuration for react-aws-s3 plugin...
// EDIT 2025-04-29: Removed for security.

const uploadDoc = async (fileData, folderPath) => {
    const formData = objectToFormData({
        file: fileData,
        bucket: 'bayan',
        folder: folderPath,
        cloudfront: 'd310ox1f4zno4b',
    });
    const res = await fetch('https://plexuss.com/ajax/postGeneralUploadDoc',  {
        method: 'POST',
        body: formData,
    });
    const resData = await res.json();
    return {...resData, location: resData.url}
};

export const S3ClientForUserProfile = {
    uploadFile: (fileData, time = null) => uploadDoc(fileData, 'user-profile-media'),
};

export const S3ClientForUserPosts = {
    uploadFile: (fileData, time = null) => uploadDoc(fileData, 'user-post-media'),
};

export const S3ClientForUserApplications = {
    uploadFile: (fileData, time = null) => uploadDoc(fileData, 'user-application-form-media'),
};

export const S3ClientForUserChat = {
    uploadFile: (fileData, time = null) => uploadDoc(fileData, 'user-chat'),
};

export const S3ClientForUserArticles = {
    uploadFile: (fileData, time = null) => uploadDoc(fileData, 'user-articles'),
};
